import { BEMBlock } from 'helpers/classnames';
import { Small } from 'palette/Typography';
import './styles/SubHeaderDropdownLink.scss';

interface SubHeaderDropdownLinkProps {
    isActive: boolean;
    href: string;
    name: string;
    backgroundColor: string;
    textColor: string;
    text: string;
    hidden: boolean;
}

function SubHeaderDropdownLink({
    isActive = false,
    href,
    name,
    backgroundColor,
    textColor,
    text,
    hidden,
    ...anchorProps
}: SubHeaderDropdownLinkProps) {
    const [block, BEMElement] = BEMBlock('sub-header-dropdown-list-item');

    return (
        <li className={block}>
            <a
                className={BEMElement('link', { active: isActive })}
                href={href}
                {...anchorProps}
                hidden={hidden}
            >
                <Small
                    className={BEMElement('name')}
                    level="1"
                >
                    {name}
                </Small>
                {text && (
                    <span
                        className={BEMElement('decorator')}
                        style={{ backgroundColor, color: textColor }}
                    >
                        {text}
                    </span>
                )}
            </a>
        </li>
    );
}

export default SubHeaderDropdownLink;
